import {DownloadForOfflineOutlined} from '@mui/icons-material';
import {MenuItem, Typography} from '@mui/material';
import styles from '../../Header.module.scss';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {UserReportModal} from './UserReportModal';
import {Permission, usePermissions} from 'utils/hooks/permissions/usePermissions';

export const UserReport = () => {
    const {roles} = usePermissions();
    const {t} = useTranslation('header');
    const [openModal, setOpenModal] = useState(false);

    const onClose = () => {
        setOpenModal(false);
    };

    if (!roles?.includes(Permission.CAN_DOWNLOAD_USER_LOGIN_REPORT)) {
        return null;
    }

    return (
        <>
            <MenuItem
                onClick={() => {
                    setOpenModal(true);
                }}
                className={styles.menuItem}
            >
                <DownloadForOfflineOutlined sx={{mr: 1}} />
                <Typography>{t('userReport')}</Typography>
            </MenuItem>
            {openModal && <UserReportModal onClose={onClose} />}
        </>
    );
};
